module.exports = __webpack_public_path__ + "../resources/img/ic_storm_weather.e462aaf1.svg";